const mutations = {};

export default mutations;



// WEBPACK FOOTER //
// ./scripts/store/mutations.js